import React, { Component } from 'react';
import styles from './MessageBox.module.css';
import {connect} from 'react-redux';
import axios from 'axios';
import sendIcon from '../../../assets/send.png';
import loader from '../../../assets/loader2.svg';
import noUser from '../../../assets/no_user.jpg';
import firebase from '../../../firebase';
import {Link} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faChevronLeft } from '@fortawesome/free-solid-svg-icons';

class MessageBox extends Component {

    state = {
        users:{},
        userId: '',
        messages: [],
        isLoading: true,
        fbRef:''
    } 

    textRef = React.createRef();
    lastMessage = React.createRef();
    componentDidMount() {
        axios.get('/users.json?auth='+ this.props.loginStatus.authToken)
        .then(response=>{
            this.setState({users: response.data});
            this.initialize();
        });
    }

    componentDidUpdate() {
        if(Object.keys(this.state.users).length !== 0 && this.props.match.params.userId !== this.state.userId) {
            this.initialize();
        }
       if(this.lastMessage.current){
        this.lastMessage.current.scrollIntoView();
        this.lastMessage.current = null;
       } 
    }

    initialize = () => {
        const userId = this.props.match.params.userId;
        if(this.state.users[userId] === undefined) this.props.history.replace({pathname:'/messages'});
        this.setState({userId: userId, messages:[], isLoading: true});

       const fbRef = firebase.database().ref('messages/' + this.props.loginStatus.userId + '/' + this.props.match.params.userId)
       fbRef.on('value', (snapShot)=>{
                this.setState({messages: snapShot.val() ? snapShot.val() : [], isLoading: false});
                if(snapShot.val() && !snapShot.val()[snapShot.val().length-1].status) {
                    const messages = snapShot.val();
                    messages[messages.length-1].status = true;
                    axios.put('/messages/' + this.props.loginStatus.userId + '/'
                    + this.props.match.params.userId + '.json?auth='+ this.props.loginStatus.authToken, messages)
                    .catch(err=>console.log(err));
                }
            });
        this.setState({fbRef: fbRef});
    }

    componentWillUnmount() {
        this.state.fbRef.off();
    }
    
    formatTime = (date) => {
        date = new Date(date);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }
    onEnterHandler = (event) => {
        if(event.key === 'Enter') this.send();
    }
    onFocus = () => {
       // this.lastMessage.current.scrollIntoView();
    }
    send = () => {
        const text = this.textRef.current.value.trim();
        if(text === '') return;
        const msgObject = {
            message: text,
            sender: this.props.loginStatus.userId,
            status: false,
            timestamp: new Date()
        };

        axios.get('/messages/' + this.props.match.params.userId 
         + '.json?auth='+ this.props.loginStatus.authToken)
        .then(response=>{
            this.textRef.current.value = '';
            if(!response.data[this.props.loginStatus.userId]) {
                response.data[this.props.loginStatus.userId] = [msgObject];
            } else {
                response.data[this.props.loginStatus.userId].push(msgObject);
            }
           
            axios.put('/messages/' + this.props.match.params.userId
             + '.json?auth='+ this.props.loginStatus.authToken, response.data)
            .catch(err=>console.log(err));

            axios.get('/messages/' + this.props.loginStatus.userId 
             + '.json?auth='+ this.props.loginStatus.authToken)
            .then(response=>{
                msgObject.status = true;
                if(!response.data[this.props.match.params.userId]) {
                    response.data[this.props.match.params.userId] = [msgObject];
                } else {
                    response.data[this.props.match.params.userId].push(msgObject);
                }
                axios.put('/messages/' + this.props.loginStatus.userId 
                 + '.json?auth='+ this.props.loginStatus.authToken, response.data)
                .catch(err=>console.log(err));
            });
        });
    }

    render() {
        const user = this.props.users[this.props.match.params.userId];
        return(
                <div className={styles.messages}>
                    <div className={styles.header}>
                        <span className={styles.back}>
                            <Link to="/messages">
                                <FontAwesomeIcon icon={faChevronLeft} size="lg" />
                            </Link>
                        </span>
                        <img src={user ? user.profilePic : noUser} width="30" height="30" alt="profile" />
                       <span> {user?.name}</span>
                       {user?.isVerified ?
                            <span style={{marginLeft:'5px'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="16px" height="16px">
                            <polygon fill="#42a5f5" points="29.62,3 33.053,8.308 39.367,8.624 39.686,14.937 44.997,
                            18.367 42.116,23.995 45,29.62 39.692,33.053 39.376,39.367 33.063,39.686 29.633,44.997 24.005,
                            42.116 18.38,45 14.947,39.692 8.633,39.376 8.314,33.063 3.003,29.633 5.884,24.005 3,18.38 8.308,
                            14.947 8.624,8.633 14.937,8.314 18.367,3.003 23.995,5.884"/>
                            <polygon fill="#fff" points="21.396,31.255 14.899,24.76 17.021,22.639 21.428,27.046 30.996,
                            17.772 33.084,19.926"/>
                            </svg>
                            </span>
                            : null
                        }
                    </div>
                    <div className={styles.body}>
                    {this.state.isLoading ?
                        <div style={{margin:'auto',marginTop:'35%'}}>
                             <img src={loader} alt="loading" width="30" height="30"/>
                        </div> : null
                    }
                    {this.state.messages.map(message => {
                    return (
                      <div className={[styles.row, message.sender === this.props.loginStatus.userId?styles.rightRow:''].join(' ')} key={message.timestamp}>
                          <div className={[styles.text, message.sender === this.props.loginStatus.userId ? 
                            styles.right : styles.left].join(' ')} ref={this.lastMessage}>
                                {message.message}
                                <sub>{this.formatTime(message.timestamp)}</sub>
                          </div>
                      </div>
                    )})}
                    </div>
                    <div className={styles.footer}>
                        <textarea placeholder="Message..." ref={this.textRef} 
                        onKeyPress={(event)=>this.onEnterHandler(event)}
                        onFocus={this.onFocus}></textarea>
                        <button onClick={this.send}>
                            <img src={sendIcon} width="22" alt="send" style={{transform: 'rotate(45deg) translate(1px, 2px)'}} />
                        </button>
                    </div>
                </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        loginStatus: state.loginStatus
    }
}
export default connect(mapStateToProps)(MessageBox);